import { Game, GameSchema, parseGameUid } from '../models/Game'
import { getFinder, getInserter } from 'src/util/src/zod'
import { todo } from '../../util/src/todo'
import {
  DiscordServer,
  FacebookPage,
  InstagramProfile,
  MediumProfile,
  RedditSubreddit,
  TelegramGroup,
  TwitterProfile,
  YouTubeChannel,
} from '../../Social/data/allSocialChannelTypes'
import { PanteraCapital } from './allInvestors'
import { Aavegotchi_GHST, Genopets_GENE, Genopets_KI, Letmespeak_LSTAR, Stepn_GMT, Stepn_GST } from './allTokens'
import { already } from '../../util/src/date'

export const allGames: Game[] = []

export const addGame = getInserter<Game>('Game', GameSchema, parseGameUid, allGames)

export const findGame = getFinder(parseGameUid, allGames)

export const Genopets = addGame({
  id: 'Genopets',
  name: 'Genopets',
  description: 'Genopets is a game that makes it rewarding to live an active lifestyle.',
  image: 'https://i.imgur.com/qSA6vvh.jpg',
  website: 'https://www.genopets.me/',
  docs: ['https://docsend.com/view/b9bqd2j78nekzdgr'],
  calculators: [],
  channels: [
    {
      type: DiscordServer,
      slug: 'genopets',
      subscriberCount: 137423,
      subscriberCountEstimatedAt: new Date('2022-04-13'),
    },
    {
      type: TwitterProfile,
      slug: 'genopets',
      subscriberCount: 159500,
      subscriberCountEstimatedAt: new Date('2022-04-13'),
    },
    {
      type: InstagramProfile,
      slug: 'genopets',
      subscriberCount: 10800,
      subscriberCountEstimatedAt: new Date('2022-04-15'),
    },
    {
      type: FacebookPage,
      slug: 'Genopets.me',
      subscriberCount: 9590,
      subscriberCountEstimatedAt: new Date('2022-04-15'),
    },
  ],
  tokens: [
    Genopets_GENE,
    Genopets_KI,
  ],
  investors: todo([
    PanteraCapital,
  ]),
  investorsCount: 17, // source: https://www.crunchbase.com/organization/genopets
  products: [],
  roadmap: 'https://docsend.com/view/b9bqd2j78nekzdgr',
  roadmapAvailableAt: already,
})

export const Aavegotchi = addGame({
  id: 'Aavegotchi',
  name: 'Aavegotchi',
  description: 'Aavegotchi is a game where players manage little ghost NFTs.',
  image: 'https://i.imgur.com/WQVTpQW.jpg',
  website: 'https://www.aavegotchi.com/',
  docs: ['https://wiki.aavegotchi.com/'],
  calculators: [],
  channels: [
    {
      type: DiscordServer,
      slug: 'Aavegotchi',
      subscriberCount: 30417,
      subscriberCountEstimatedAt: new Date('2022-04-18'),
    },
    {
      type: TwitterProfile,
      slug: 'Aavegotchi',
      subscriberCount: 95800,
      subscriberCountEstimatedAt: new Date('2022-04-18'),
    },
    {
      type: YouTubeChannel,
      slug: 'Aavegotchi',
      subscriberCount: 1440,
      subscriberCountEstimatedAt: new Date('2022-04-18'),
    },
    {
      type: TelegramGroup,
      slug: 'Aavegotchi',
      subscriberCount: 10616,
      subscriberCountEstimatedAt: new Date('2022-04-18'),
    },
    {
      type: RedditSubreddit,
      slug: 'Aavegotchi',
      subscriberCount: 2300,
      subscriberCountEstimatedAt: new Date('2022-04-18'),
    },
  ],
  tokens: todo([
    Aavegotchi_GHST,
  ]),
  investors: todo([
  ]),
  investorsCount: todo(0),
  products: [],
  roadmap: 'https://aavegotchi.medium.com/aavegotchi-development-roadmap-v2-15820dcf84de',
  roadmapAvailableAt: already,
})

export const Stepn = addGame({
  id: 'Stepn',
  name: 'STEPN',
  description: 'STEPN is a game where you get paid for running / walking in real life.',
  image: 'https://i.imgur.com/9DKJD5v.png',
  website: 'https://stepn.com/',
  docs: ['https://whitepaper.stepn.com/'],
  calculators: [
    'https://stepn.wiki/',
    'https://stepn.guide/',
    'https://www.workitwallet.com/post/stepn-roi-calculator',
  ],
  channels: [
    {
      type: TwitterProfile,
      slug: 'Stepnofficial',
      subscriberCount: 269800,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: TelegramGroup,
      slug: 'STEPNofficial',
      subscriberCount: 144609,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: DiscordServer,
      slug: 'stepn',
      subscriberCount: 222201,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: InstagramProfile,
      slug: 'stepncom',
      subscriberCount: 14700,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: MediumProfile,
      slug: 'stepnofficial',
      subscriberCount: 8300,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: RedditSubreddit,
      slug: 'StepN',
      subscriberCount: 16000,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
  ],
  tokens: [
    Stepn_GST,
    Stepn_GMT,
  ],
  investors: todo([
  ]),
  investorsCount: todo(0),
  products: [],
  roadmapAvailableAt: null,
})

export const Sorare = addGame({
  id: 'Sorare',
  name: 'Sorare',
  description: 'Sorare is a fantasy football game where players buy, sell, trade, and manage a virtual team with NFT player cards.',
  image: 'https://i.imgur.com/fUlRsLc.jpg',
  website: 'https://sorare.com/',
  docs: ['https://help.sorare.com/'],
  calculators: [
    'https://www.soraredata.com/',
  ],
  channels: [
    {
      type: TwitterProfile,
      slug: 'sorare',
      subscriberCount: 94600,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: TelegramGroup,
      slug: 'SorareFC',
      subscriberCount: 3479,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: InstagramProfile,
      slug: 'sorare',
      subscriberCount: 40700,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: DiscordServer,
      slug: 'TSjtHaM',
      subscriberCount: 47074,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
    {
      type: RedditSubreddit,
      slug: 'Sorare',
      subscriberCount: 7000,
      subscriberCountEstimatedAt: new Date('2022-04-19'),
    },
  ],
  tokens: todo([
  ]),
  investors: todo([
  ]),
  investorsCount: todo(0),
  products: [],
  roadmap: todo('https://www.google.com/'),
  roadmapAvailableAt: todo(null),
})

export const Decentraland = addGame({
  id: 'Decentraland',
  name: 'Decentraland',
  description: '',
  image: 'https://i.imgur.com/poFVp7E.jpg',
  website: 'https://decentraland.org/',
  docs: [],
  calculators: [],
  channels: todo([

  ]),
  tokens: todo([
    // MANA
  ]),
  investors: todo([
  ]),
  investorsCount: todo(0),
  products: [],
  roadmap: todo('https://www.google.com/'),
  roadmapAvailableAt: todo(null),
})

export const Letmespeak = addGame({
  id: 'Letmespeak',
  name: 'Letmespeak',
  description: 'Learn to earn game where you can improve your english skill level',
  image: 'https://i.imgur.com/wC5zz92.png',
  website: 'https://www.letmespeak.org/',
  docs: ['https://letmespeak.medium.com/let-me-speak-economic-model-f95a31ae0ef8'],
  calculators: [],
  channels: [
    {
      type: TwitterProfile,
      slug: 'Letmespeak_org',
      subscriberCount: 987000,
      subscriberCountEstimatedAt: new Date('2022-04-26'),
    },
    {
      type: TelegramGroup,
      slug: 'letmespeak_org',
      subscriberCount: 100500,
      subscriberCountEstimatedAt: new Date('2022-04-26'),
    },
    {
      type: InstagramProfile,
      slug: 'letmespeak_org',
      subscriberCount: 113000,
      subscriberCountEstimatedAt: new Date('2022-04-26'),
    },
    {
      type: DiscordServer,
      slug: 'letmespeak',
      subscriberCount: 5800,
      subscriberCountEstimatedAt: new Date('2022-04-26'),
    },

  ],
  tokens: todo([
    Letmespeak_LSTAR,
  ]),
  investors: todo([
  ]),
  investorsCount: todo(0),
  products: [],
  roadmapAvailableAt: todo(null),
})
